// i18n area 'storage' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.ru-RU.meta.json.
import type { enUS } from './storage'

export const ruRU: typeof enUS = {
  storage: {
    pools: {
      title: 'Хранилища',
      createTitle: 'Создать хранилище',
      path: 'Путь',
      pathHint: 'Абсолютный путь внутри разрешенного корня (по умолчанию /var/lib/tvirt/pools/)',
      shared: 'Общее хранилище',
      sharedChip: 'общее',
      sharedVerifiedChip: 'общее · проверено',
      sharedVerifiedTooltip: 'Общий доступ проверен: перекрестные пробы подтверждают, что каждый участник видит данные, записанные остальными.',
      sharedDisputedChip: 'общее · НЕ проверено',
      sharedDisputedTooltip: 'Общий доступ НЕ проверен',
      sharedDisputedPair: '{observer} не видит данные, записанные узлом {writer}',
      sharedHint: 'Сетевой ресурс, смонтированный локально по одному и тому же пути на каждом участнике — обязательное условие живой миграции (объявляется вручную).',
      sharedDanger: 'ОПАСНО — TVirt ВЕРИТ этому флагу: если его включить, каждый участник считает, что видит ТЕ ЖЕ САМЫЕ байты по этому пути. На папке, которая НЕ является по-настоящему общим ресурсом (NFS/CIFS/кластерная файловая система), результатом станут повреждение и потеря данных при первой же миграции или первом запуске HA на другом узле. Включайте только если путь — это ресурс, смонтированный одинаково на каждом узле.',
      type: 'Тип',
      capacity: 'Емкость',
      provisioned: 'Выделено',
      provisionedOvercommit: 'Потенциальные обязательства превышают емкость: тонкие тома могут вырасти до {n} GiB.',
      phase: { ready: 'Готово', degraded: 'Деградировало', error: 'Ошибка' },

      // Раунд #156 (стандартный диалог): ПОЛНЫЙ диалог деталей — вкладки,
      // строки конфигурации по драйверам и наблюдаемая поверхность.
      tabConfig: 'Конфигурация',
      tabCapacity: 'Емкость и состояние',
      cardIdentity: 'Идентификация',
      cardPlacement: 'Размещение',
      cardConnection: 'Подключение',
      usedReal: 'Реально занято',
      capacityUnknown: 'Узел еще не сообщил емкость этого пула — здесь числа не выдумывают',
      overcommitHint: 'Выделено больше емкости: для тонких пулов это нормально, следите за реально занятым местом',
      supportedContent: 'Поддерживаемое содержимое',
      content: {
        disks: 'Диски',
        catalogFiles: 'Файлы каталогов',
        backups: 'Резервные копии',
        appVolumes: 'Тома приложений'
      },
      defaultDiskFormat: 'Формат диска по умолчанию',
      reserveGiB: 'Зарезервированное свободное место (GiB)',
      available: 'Доступно',
      diskCount: 'Диски',
      filesystem: 'Файловая система',
      observedAt: 'Наблюдалось',
      lostAtRow: 'Объявлено потерянным',
      sharedProbeRow: 'Проверка общего доступа',
      sharedProbeNodes: 'Опрошенные узлы',
      reachableFrom: 'Объявленная достижимость',
      reachableFromHint: 'Узлы, с которых это хранилище должно быть достижимо. ВМ с дисками, образами ISO или метаданными здесь не запустится и не мигрирует на узел вне этого списка. Все участники выбраны заранее: сужайте список как считаете нужным. Узел, вошедший в кластер позже, останется снаружи, пока вы не добавите его сюда.',
      reachableFromNone: 'не объявлена',
      reachableFromTags: 'Достижимость по тегам',
      reachableFromTagsHint: 'Селектор тег=значение (записи через запятую, соединяются по И): каждый участник с этими тегами объявляется достижимым — динамически: пометьте узел тегом, и он войдет в список.',
      reachableFromTagsInvalid: 'Неверный формат — используйте тег=значение, через запятую',
      reachableResolved: 'Разрешенные узлы: {nodes}',
      reachableDeclaredNotSeen: 'объявлено, но проба общего доступа этого не видит на: {nodes}',
      reachableSeenNotDeclared: 'видно, но не объявлено (вне периметра) на: {nodes}',
      cephCluster: 'Управляемый кластер Ceph',
      appGuardTitle: 'Хранилище используется приложениями',
      appEphemeralGuard: 'это хранилище является эфемерным пулом приложений на уровне кластера — сначала смените его на странице приложений, потом удаляйте.',
      appInUseGuard: 'здесь живут корневые ФС и тома приложений: {apps} — сначала перенесите или удалите их.',
      releaseRequiredTitle: 'Удалить «{name}» и освободить его образы?',
      releaseRequiredBatchTitle: 'Удалить выбранные storage и освободить их образы?',
      releaseRequiredBody: 'Освобождение образов НЕ удаляет ни одного байта: снятие с регистрации оставляет namespace на диске, образы просто перестают быть материализованными, а каждая ссылка из scope выживает как claim — зарегистрируйте pool заново, и они будут усыновлены снова.',
      releaseConfirm: 'Удалить и освободить образы'
    },
    lost: {
      chip: 'Потеряно',
      action: 'Объявить потерянным',
      confirmTitle: 'Объявить хранилище потерянным',
      confirmBody: 'Свидетельство оператора под его объявленную ответственность: каждая задача в очереди или в работе над этим хранилищем и его объектами ПРОВАЛИТСЯ, удаления станут чисто реестровыми (никакой работы с файловой системой), а новая физическая работа будет отклоняться. Байты при этом никто не трогает — если том вернется к жизни, зарегистрируйте его снова и запустите сканирование, чтобы все принять обратно.',
      confirmSubmit: 'Объявить потерянным',
      error: 'Свидетельство отклонено'
    },
    findings: {
      action: 'Найденные объекты',
      title: 'Найденные объекты',
      empty: 'В пространстве имен хранилища ничего не найдено',
      loadError: 'Не удалось загрузить найденные объекты',
      actionError: 'Решение отклонено',
      colKind: 'Тип',
      colObject: 'Объект',
      colConflict: 'Конфликт',
      namespaceNotice:
        'Этот каталог уже был инициализирован другим хранилищем: печать идентичности перезаписана печатью текущего хранилища. Содержимое НЕ тронуто — просмотрите найденные ниже объекты, импортируйте нужные, а затем закройте это уведомление.',
      kind: {
        disk: 'Диск',
        catalogFile: 'Файл каталога',
        vmMetadata: 'Метаданные ВМ',
        namespace: 'Пространство имен',
        foreign: 'Чужое',
        volumeGroup: 'Группа томов'
      },
      vgAdopt: {
        action: 'Принять группу томов',
        title: 'Принять группу томов',
        intro:
          'Это устройство уже несёт группу томов с именем TVirt, но её печать не называет ни одного зарегистрированного здесь storage. Это может быть то, что предыдущий storage ЭТОГО кластера оставил на LUN, — или то, что ДРУГОЙ кластер TVirt оставил на LUN, сменившей владельца: отсюда оба случая выглядят одинаково, и поэтому никто не решает за вас.',
        irreversible: 'Посмотрите на устройство, печать и имя, прежде чем продолжить: принятие необратимо.',
        device: 'Устройство',
        seal: 'Печать',
        sealNone: 'нет (нет тега tvirt.storageId)',
        renameTo: 'Будет переименована в',
        renameNone: 'Без переименования: имя уже то, которое выводит этот storage',
        volumesNote:
          'Тома внутри НЕ принимаются этим жестом: следующее сканирование предложит их по одному, как обычные найденные объекты.'
      },
      conflictChip: 'ID уже существует',
      dismissedChip: 'Пропущено',
      adopt: 'Принять',
      adoptFileTitle: 'Импорт в каталог',
      adoptFileHint: 'Файлы существуют только внутри каталогов: выберите каталог назначения для найденного файла.',
      purge: 'Удалить с диска',
      dismiss: 'Пропустить',
      purgeConfirmTitle: 'Удалить с диска',
      purgeConfirmBody: 'Найденные байты объекта {id} будут стерты из хранилища. Операция необратима.',
      taskStarted: 'Запущено — продолжается фоновой задачей',
      scan: 'Сканировать хранилище',
      scanStarted: 'Сканирование запущено…',
      scanDone: 'Сканирование завершено — список найденных объектов обновлен'
    },
    reinit: {
      action: 'Повторить инициализацию'
    },
    wizard: {
      addButton: 'Добавить',
      title: 'Добавление хранилища',
      back: 'Назад',
      continue: 'Далее',
      selectHint: 'Выберите протокол, чтобы увидеть, как его использует TVirt.',
      roadmap: 'Дорожная карта',
      server: 'Сервер',
      export: 'Экспортируемый путь',
      share: 'Общий ресурс',
      username: 'Имя пользователя',
      password: 'Пароль',
      passwordHint: 'Только на запись: используется при монтировании и больше не показывается.',
      credential: 'Учетные данные',
      credentialManual: 'Ввести вручную',
      credentialHint: 'Запись хранилища учетных данных вида «пользователь и пароль» — альтернатива вводу их здесь.',
      credentialEmpty: 'В хранилище нет учетных данных вида «пользователь и пароль» — создайте их в разделе «Система → Учетные данные» или введите учетную запись ниже.',
      options: 'Параметры монтирования',
      optionsHint: 'Через запятую, передаются в mount -o как есть.',
      portal: 'Портал',
      portalHint: 'хост[:порт] — порт по умолчанию 3260.',
      target: 'IQN таргета',
      targetHint: 'Имя таргета iSCSI, начинается с iqn.',
      lun: 'LUN',
      wholeLunRow: 'На дисках: это хранилище называет только таргет',
      wholeLunHint: 'Это хранилище называет только таргет: его LUN становятся дисками по одному (Создать диск → принять целый LUN), на таргет ничего не пишется.',
      lunHint: 'Номер LUN на таргете — 0, если сомневаетесь.',
      chapCredential: 'Учетные данные (CHAP)',
      chapCredentialHint: 'Запись хранилища учетных данных типа CHAP (iSCSI), используемая при входе — секрет никогда не путешествует вместе с хранилищем.',
      chapNone: 'Без аутентификации',
      chapEmpty: 'В хранилище нет учетных данных типа CHAP (iSCSI) — создайте их в разделе «Система → Учетные данные». Без них вход останется без аутентификации.',
      address: 'Адрес',
      addressHint: 'Хост или IP таргета NVMe/TCP (traddr).',
      port: 'Порт',
      portHint: 'TCP-порт таргета — 4420, если оставить пустым.',
      targetNqn: 'NQN таргета',
      targetNqnHint: 'NQN подсистемы на таргете, начинается с nqn.',
      nsid: 'NSID',
      nsidHint: 'ID пространства имен внутри подсистемы — 1, если сомневаетесь.',
      dhchapCredential: 'Учетные данные (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Запись хранилища учетных данных типа DH-HMAC-CHAP (NVMe), используемая при подключении — секрет никогда не путешествует вместе с хранилищем.',
      dhchapNone: 'Без аутентификации',
      dhchapEmpty: 'В хранилище нет учетных данных типа DH-HMAC-CHAP (NVMe) — создайте их в разделе «Система → Учетные данные». Без них подключение останется без аутентификации.',
      monitors: 'Мониторы',
      monitorsHint: 'Адреса мониторов Ceph, хост[:порт], через запятую или с новой строки — порт по умолчанию 6789.',
      pool: 'Пул',
      poolHint: 'Пул RBD, который будет использоваться — по одному образу RBD на диск.',
      fs: 'Файловая система',
      fsHint: 'Имя файловой системы CephFS (mds_namespace при монтировании).',
      fsPath: 'Путь внутри файловой системы',
      fsPathHint: 'Абсолютный путь внутри файловой системы, который монтирует хранилище — /, если сомневаетесь.',
      cephxCredential: 'Учетные данные (cephx)',
      cephxCredentialHint: 'Запись хранилища учетных данных типа cephx: имя пользователя = имя клиента (client.…), секрет = ключ в base64. Обязательны.',
      cephxNone: 'В хранилище нет учетных данных cephx — создайте их (тип: cephx) в разделе «Система → Учетные данные» или позвольте управляемому кластеру Ceph выпустить их действием «Предложить как хранилище».',
      sharedByNature: 'Сетевые хранилища общие по своей природе: каждый участник монтирует их по одному и тому же пути, которым управляет TVirt.',
      error: 'Хранилище отклонено',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Другое',
        legacy: 'Устаревшее'
      },
      legacyHint: 'Поддерживаются в полном объеме — просто мы не выбрали бы их для новой установки.',
      proto: {
        // Строка `usage` (Лука, 2026-07-24) говорит, как TVirt использует
        // протокол — прежде всего допустимое содержимое: dir/nfs/cifs держат
        // диски И образы ISO/дисков и шаблоны, блочные драйверы
        // (iscsi/nvme-tcp/rbd) — ТОЛЬКО диски.
        dir: {
          name: 'Локальная папка',
          desc: 'Директория на узле: просто и быстро. Она ЛОКАЛЬНА для узла, если только путь не является по-настоящему общим ресурсом — пометка «общее» там, где это не так, стоит данных.',
          usage: 'TVirt держит здесь диски ВМ, образы ISO и дисков и шаблоны.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Экспорт NFS, смонтированный кластером — общий по своей природе.',
          usage: 'Держит диски ВМ, образы ISO и дисков и шаблоны.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Ресурс Windows/Samba, смонтированный кластером — общий по своей природе.',
          usage: 'Держит диски ВМ, образы ISO и дисков и шаблоны.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Удаленная файловая система по SSH — без всякого экспорта с NAS.',
          usage: 'В дорожной карте.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Блочные LUN по IP с общим LVM поверх.',
          usage: 'Только диски — по одному тонкому тому на диск; образы ISO и шаблоны здесь не живут.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Блочные устройства, распределенные по кластеру Ceph.',
          usage: 'Только диски — по одному образу RBD на диск, открывается напрямую из QEMU; образы ISO здесь не живут.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Распределенная файловая система Ceph, монтируемая ядром на узлах кластера — общая по своей природе.',
          usage: 'Держит диски ВМ, образы ISO и дисков и шаблоны — семейство dir поверх файловой системы Ceph (учетные данные cephx обязательны).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN SCSI на фабрике FibreChannel — классическая SAN на FC.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Тот же SCSI поверх FibreChannel, но кадры FC инкапсулированы в Ethernet.' },

        // Живет с раунда #132 — ключ это имя драйвера из контракта,
        // чтобы чип в списке хранилищ разрешался в ту же запись.
        'iscsi-lun': {
          name: 'iSCSI (целые LUN)',
          desc: 'iSCSI-таргет как носитель целых LUN: каждый диск — ЭТО LUN, передаваемый гостю как есть — без LVM посередине.',
          usage: 'Только диски — один целый LUN на диск, принятый как есть; SAN-дом дисков с общей записью.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (целые namespace)',
          desc: 'NVMe-подсистема как носитель целых namespace: каждый диск — ЭТО namespace, передаваемый гостю как есть.',
          usage: 'Только диски — один целый namespace на диск, принятый как есть; общая запись — да, SCSI persistent reservations — нет.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Удаленный NVMe — никакого SCSI на пути — поверх обычного TCP, с общим LVM сверху.',
          usage: 'Только диски — по одному тонкому тому на диск; образы ISO и шаблоны здесь не живут.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Удаленный NVMe на фабрике FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe на фабрике FibreChannel, которую FCoE переносит внутри Ethernet — слои FCoE и NVMe/FC, поставленные друг на друга.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI с путем данных, перенесенным на RDMA — на любой фабрике (InfiniBand, iWARP, RoCE). Вытеснен NVMe/RDMA, но до сих пор встречается в массивах и в ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Родной SCSI поверх RDMA, эпоха до iSER: InfiniBand (с обнаружением фабрики) и RoCE — доживает свой век в старых системах хранения для HPC.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Удаленный NVMe на любой фабрике RDMA — InfiniBand, iWARP, RoCE v1 и v2: настройка одна, а какая фабрика есть, говорит сам узел.' },
        s3: { name: 'S3', desc: 'Объектное хранилище, совместимое с S3 — образы и резервные копии.' }
      }
    },
    catalogs: {
      title: 'Каталоги',
      createTitle: 'Создать каталог',
      editTitle: 'Изменить каталог',
      docTitle: 'Каталог',
      notFound: 'Такого каталога (уже?) нет',
      scopeHint: 'Кто читает этот скоуп, видит каждый файл каталога и может им пользоваться',
      files: 'Файлы',
      noFiles: 'Файлов нет',
      count: {
        iso: 'ISO',
        ctRootfs: 'Шабл. CT',
        vmTemplate: 'Шабл. ВМ',
        ociImage: 'OCI',
        firmwareOvmf: 'Прошивки'
      },

      // Системный каталог (раунд #126): дом встроенных объектов платформы —
      // читать может каждый, писать не может никто.
      systemChip: 'системный',
      systemTooltip: 'Системный каталог: в нем живут встроенные объекты платформы, изменить его нельзя'
    },

    // Файлы каталога (раунд K1, inventory v2e/v2g): каталог — это дом
    // файловых артефактов кластера: один список, заголовки по kind.
    catalogFiles: {
      catalog: 'Каталог',
      kindLabel: 'Тип',
      physicalSize: 'Физический размер',
      virtualSize: 'Виртуальный размер',

      // Раунд K3 (#64) + K4 (#65, ova/ovf с отображением boot-survival):
      // материализует файл vm-template как шаблон ВМ в инвентаре.
      importTemplateAction: 'Импортировать как шаблон ВМ',
      importTemplateLegacy: 'Формат не объявлен — годится как заготовка для дисков, импортировать нельзя',
      importTemplateTitle: 'Импорт как шаблона ВМ',
      importTemplateSubmit: 'Импортировать',
      importTemplateError: 'Импорт не удался',
      importTemplateHint: 'Пакет .tvtpl становится шаблоном ВМ: замороженное оборудование из манифеста плюс по диску на каждую запись архива, и каждый проверяется по своей контрольной сумме. NIC и приводы CD/DVD в архив не входят — добавьте их после импорта.',
      importTemplateQcow2Hint: 'Голый qcow2 становится шаблоном с ОДНИМ диском и объявленным оборудованием по умолчанию: профиль linux, UEFI, 2 vCPU, 2048 MiB, загрузка с единственного диска. Поправьте при развертывании.',
      importTemplateName: 'Имя шаблона',
      importTemplateNameHint: 'Пусто = {name} (-import-<n>, если занято)',
      importTemplateStorage: 'Хранилище для дисков',
      importTemplateMetadataStorage: 'Хранилище метаданных',
      importTemplateMetadataHint: 'Блочное хранилище не держит метаданные ВМ (прошивку, varstore) — выберите dir/nfs/cifs.',
      importTemplateStarted: 'Импорт запущен — шаблон появится на вкладке «Шаблоны», когда задача завершится.',

      // Говорящие подписи в единственном числе (#86): найденные объекты и
      // перепись говорят, ЧТО это за файл — общее «Файл каталога» остается
      // только запасным вариантом.
      kind: {
        iso: 'Образ ISO',
        'ct-rootfs': 'Корневая ФС CT',
        'vm-template': 'Шаблон ВМ',
        'oci-image': 'Образ OCI',
        'firmware-ovmf': 'Прошивка OVMF'
      },
      title: {
        iso: 'Образы ISO',
        'ct-rootfs': 'Шаблоны CT',
        'vm-template': 'Шаблоны ВМ',
        'oci-image': 'Образы OCI',
        'firmware-ovmf': 'Прошивки OVMF'
      },
      createTitle: {
        iso: 'Добавить образ ISO',
        'ct-rootfs': 'Зарегистрировать шаблон CT',
        'vm-template': 'Добавить шаблон ВМ',
        'oci-image': 'Добавить образ OCI',
        'firmware-ovmf': 'Добавить прошивку OVMF'
      },
      formatHint: 'Выводится из расширения выбранного файла — поправьте, если угадано неверно',
      tarballHint: 'tar-архив корневой ФС в стандартном формате LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 или простой .tar)',
      ociArchiveHint: 'tar-архив docker-archive / oci-archive (.tar или .tar.gz), например полученный из docker save',
      uploadResumeHint: 'Отправка прервана — файл ждет загрузки: отправьте тот же файл снова, чтобы продолжить',
      moveTitle: 'Перемещение файла',
      moveHint: 'Два независимых измерения: Каталог перемещает ссылку (тот же id, ни один байт не переезжает, scope становится scope каталога назначения); Хранилище перемещает данные — за ними следует каждая связанная копия, пока файл используется, перемещение отклоняется. Выбраны вместе: сначала каталог, затем хранилище.',
      moveCatalog: 'Каталог назначения',
      moveCatalogHint: 'Дом меняет только ссылка: VM, подключившая файл, должна видеть каталог назначения',
      keepCurrent: 'Не менять',
      rehomed: 'Ссылка перемещена в выбранный каталог',
      copyAction: 'Копировать в каталог…',
      copyTitle: 'Копирование в каталог',
      copyLinkHint: 'Копия — это новая ссылка на те же данные: в хранилище ничего не дублируется.',
      copyCatalog: 'Каталог назначения',
      copyCatalogHint: 'Копирование — это способ, которым файл путешествует между каталогами',
      sameCatalog: 'Тот же, что у источника',
      sharedObjectHint: 'Данные этого файла используются связанными копиями: {count}',
      deleteLastLink: 'Это ПОСЛЕДНЯЯ ссылка на это содержимое: данные в хранилище тоже будут удалены.',
      deleteLinkOnly: 'Будет убрана только эта ссылка — данные останутся и будут доступны из других связанных копий ({count}).',
      noCatalog: 'Каталогов нет — создайте хотя бы один',
      inlineCatalogName: 'Имя каталога',

      // Файлы, встроенные в платформу (раунд #126): хранилище null — их
      // читают и клонируют, но никогда не перемещают, не удаляют и не
      // переименовывают.
      embeddedChip: 'встроенный',
      embeddedStorage: 'Встроен в платформу',
      embeddedNoMove: 'Встроенный файл платформы: он не живет ни в одном хранилище — вместо перемещения клонируйте его',
      embeddedCopyHint: 'Клон материализует встроенные байты в настоящем хранилище: выберите хранилище и каталог назначения — копия будет обычным файлом',
      sourceEmbedded: 'Встроен в платформу',
      nodesRow: 'Наличие по узлам',
      nodesSummary: '{present} из {total} узлов имеют его',
      nodePresent: 'есть',
      nodeMissing: 'отсутствует',
      nodeUnknown: 'ещё не сообщено',
      nodesHint: 'Ресурс живёт на диске каждого узла (пакет trantor-tvirt-assets): узел без него не может ни определить VM с этой прошивкой, ни предоставить Guest Tools. Разные версии на узлах — норма во время поэтапного обновления.',

      // Скачивание (раунд #108): байты уезжают только со своим отдельным правом.
      downloadAction: 'Скачать',
      downloadNotReady: 'Содержимое еще не готово — для скачивания файл должен быть готов',
      downloadDenied: 'Ваша роль не включает catalog.download — скачивание байтов это право, отдельное от использования файла',

      // Раунд #156 (стандартный диалог): недостающие строки для чтения в
      // диалоге деталей — факты об общем объекте, объявленная контрольная
      // сумма, потребители.
      objectRow: 'Объект хранилища',
      objectLinksRow: 'Связанные копии',
      declaredChecksum: 'Объявленный SHA-256',
      usedByRow: 'Используется',
      usedByVms: 'ВМ',
      usedByDisks: 'Диски',
      transferRow: 'Передача',
      storageLockHint: 'Меняется только действием «Переместить»'
    },

    // Перепись по каждому хранилищу (раунд K1, inventory v2b #2): только
    // чтение, каждым объектом управляют из его раздела.
    objects: {
      action: 'Просмотреть содержимое',
      title: 'Содержимое хранилища',
      hint: 'Перепись только для чтения: что живет в этом хранилище — каждым объектом управляют из его раздела.',
      empty: 'В этом хранилище нет зарегистрированных объектов',
      loadError: 'Не удалось загрузить содержимое',
      colDetail: 'Подробности',
      manage: 'Управлять в своем разделе',
      kind: {
        disk: 'Диск',
        catalogFile: 'Файл каталога',
        ociBlob: 'Блоб OCI',
        checkpoint: 'Контрольная точка',
        vmMetadata: 'Метаданные ВМ',
        appRoot: 'Корневая ФС приложения',
        appVolume: 'Том приложения'
      }
    },
    inventory: {
      tabCatalogs: 'Каталоги',
      storage: 'Хранилище',
      sizeGib: 'Размер (GiB)',
      format: 'Формат',
      size: 'Размер',
      sourceType: 'Источник',
      sourceFile: 'Отправка файла',
      sourceUrl: 'Скачивание по URL',
      file: 'Файл',
      url: 'URL',
      checksum: 'Контрольная сумма SHA-256',
      checksumHint: 'Обязательно: скачанное проверяется по этой сумме SHA-256',
      verifyChecksum: 'Проверять контрольную сумму',
      checksumOffHint: 'Скачивание будет принято без проверки — вычисленный SHA-256 все равно записывается',
      uploading: 'Отправка…',
      move: {
        action: 'Переместить',
        diskTitle: 'Перемещение диска',
        target: 'Хранилище назначения',
        diskHint: 'Диск сохраняет свою личность: байты переезжают в выбранное хранилище. ВМ, которая его использует, должна быть выключена; при наличии снимков сторона iSCSI отклоняет перемещение.',
        noTargets: 'Совместимых хранилищ назначения нет',
        submit: 'Переместить',
        error: 'Перемещение отклонено'
      },
      clone: {
        action: 'Клонировать',
        title: 'Клонирование диска',
        name: 'Имя копии',
        storage: 'Хранилище назначения',
        sameStorage: 'То же, что у источника',
        linked: 'Связанный клон',
        linkedHint: 'Мгновенный оверлей qcow2, сцепленный с исходным диском (только для источников qcow2). По умолчанию делается полная копия.',
        linkedCrossHint: 'Связанный клон остается в хранилище источника: выберите «То же, что у источника», чтобы включить его.',
        submit: 'Клонировать',
        error: 'Клонирование отклонено'
      },
      copy: {
        action: 'Копировать',
        name: 'Имя копии',
        storage: 'Хранилище назначения',
        sameStorage: 'То же, что у источника',
        submit: 'Копировать',
        error: 'Копирование отклонено'
      },
      taskStarted: 'Запущено — продолжается фоновой задачей',
      cephObjects: 'Перейти к деталям объекта в Ceph',
      phase: {
        ready: 'Готово',
        creating: 'Создается',
        'awaiting-upload': 'Ожидает отправки',
        downloading: 'Скачивается',
        verifying: 'Проверяется',
        deleting: 'Удаляется',
        error: 'Ошибка',
        'in-use': 'Используется'
      }
    }
  }
}
